import {
  getAppIdFromHostDomain,
  resolveBrandclubHostDomain,
} from "@brandclub/common-ui";

export { isShopifyPreviewHost } from "@brandclub/common-ui";

export const HOST_DOMAIN = resolveBrandclubHostDomain();

/**
 * The APPID is the domain name without the protocol.
 * For example, if the HOST_DOMAIN is "https://example.com",
 * the APPID will be "example.com".
 */
export const APPID = getAppIdFromHostDomain(HOST_DOMAIN);
